import { atom } from "recoil";

export default atom({
  key: "editingFileIdState",
  default: null,
});
